import { CALL_API } from '../middleware/ApiMiddleware';

export const CREATE_WEBHOOK_REQUEST = 'CREATE_WEBHOOK_REQUEST';
export const CREATE_WEBHOOK_FAILURE = 'CREATE_WEBHOOK_FAILURE';
export const CREATE_WEBHOOK_SUCCESS = 'CREATE_WEBHOOK_SUCCESS';

export const EDIT_WEBHOOK_REQUEST = 'EDIT_WEBHOOK_REQUEST';
export const EDIT_WEBHOOK_FAILURE = 'EDIT_WEBHOOK_FAILURE';
export const EDIT_WEBHOOK_SUCCESS = 'EDIT_WEBHOOK_SUCCESS';

export const GET_WEBHOOK_REQUEST = 'GET_WEBHOOK_REQUEST';
export const GET_WEBHOOK_FAILURE = 'GET_WEBHOOK_FAILURE';
export const GET_WEBHOOK_SUCCESS = 'GET_WEBHOOK_SUCCESS';

export const GET_WEBHOOK_LIST_REQUEST = 'GET_WEBHOOK_LIST_REQUEST';
export const GET_WEBHOOK_LIST_FAILURE = 'GET_WEBHOOK_LIST_FAILURE';
export const GET_WEBHOOK_LIST_SUCCESS = 'GET_WEBHOOK_LIST_SUCCESS';

export const DELETE_WEBHOOK_REQUEST = 'DELETE_WEBHOOK_REQUEST';
export const DELETE_WEBHOOK_FAILURE = 'DELETE_WEBHOOK_FAILURE';
export const DELETE_WEBHOOK_SUCCESS = 'DELETE_WEBHOOK_SUCCESS';

export const TEST_WEBHOOK_REQUEST = 'TEST_WEBHOOK_REQUEST';
export const TEST_WEBHOOK_FAILURE = 'TEST_WEBHOOK_FAILURE';
export const TEST_WEBHOOK_SUCCESS = 'TEST_WEBHOOK_SUCCESS';

const baseURL = 'config/webhooks';

export const createWebhook = (webhookRequest: IWebhookRequest) => ({
  [CALL_API]: {
    endpoint: `${baseURL}`,
    method: 'post',
    body: webhookRequest,
    authenticated: true,
    types: [CREATE_WEBHOOK_REQUEST, CREATE_WEBHOOK_SUCCESS, CREATE_WEBHOOK_FAILURE],
  },
});

export const updateWebhook = (webhookId: number, webhookRequest: IWebhookRequest) => ({
  [CALL_API]: {
    endpoint: `${baseURL}/${webhookId}`,
    method: 'put',
    body: webhookRequest,
    authenticated: true,
    types: [EDIT_WEBHOOK_REQUEST, EDIT_WEBHOOK_SUCCESS, EDIT_WEBHOOK_FAILURE],
  },
});

export const fetchWebhook = (webhookId: number) => ({
  [CALL_API]: {
    endpoint: `${baseURL}/${webhookId}`,
    method: 'get',
    authenticated: true,
    types: [GET_WEBHOOK_REQUEST, GET_WEBHOOK_SUCCESS, GET_WEBHOOK_FAILURE],
  },
});

export const fetchWebhookList = () => ({
  [CALL_API]: {
    endpoint: `${baseURL}`,
    method: 'get',
    authenticated: true,
    types: [GET_WEBHOOK_LIST_REQUEST, GET_WEBHOOK_LIST_SUCCESS, GET_WEBHOOK_LIST_FAILURE],
  },
});

export const deleteWebhook = (webhookId: number) => ({
  [CALL_API]: {
    endpoint: `${baseURL}/${webhookId}`,
    method: 'delete',
    authenticated: true,
    types: [DELETE_WEBHOOK_REQUEST, DELETE_WEBHOOK_SUCCESS, DELETE_WEBHOOK_FAILURE],
  },
});

export const testWebhookRequest = (requestPayload: IWebhookRequestPayloadObj, webhookId: number) => ({
  [CALL_API]: {
    endpoint: `${baseURL}/${webhookId}/test`,
    method: 'post',
    body: requestPayload,
    authenticated: true,
    types: [TEST_WEBHOOK_REQUEST, TEST_WEBHOOK_SUCCESS, TEST_WEBHOOK_FAILURE],
  },
});
